import { Row } from '@/components/SettingsLayout';
import { Button } from '@/ui/Button/Button';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

type Props = {
  isUpdating: boolean;
  isReadOnly?: boolean;
  canSave?: boolean;
};

const PricingFormFooter = ({ isUpdating, isReadOnly = false, canSave = true }: Props) => {
  const { t } = useTranslation();
  const {
    formState: { isDirty },
    reset,
  } = useFormContext();

  const handleCancel = () => {
    reset();
  };

  return (
    <Row justify='justify-end' gapSize='12'>
      <Button
        type='button'
        variant='outline'
        onClick={handleCancel}
        disabled={isUpdating || isReadOnly || !isDirty}
        testId='pricing-cancel'
      >
        {t('Shared.cancel')}
      </Button>
      <Button
        type='submit'
        variant='primary'
        disabled={isUpdating || isReadOnly || !isDirty || !canSave}
        testId='pricing-save'
      >
        {isUpdating ? t('Shared.saving') : t('Shared.save')}
      </Button>
    </Row>
  );
};

export default PricingFormFooter;
